import { render, staticRenderFns } from "./UndoRedoStack.vue?vue&type=template&id=36e354e2&scoped=true"
import script from "./UndoRedoStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./UndoRedoStack.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UndoRedoStack.vue?vue&type=style&index=0&id=36e354e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e354e2",
  null
  
)

export default component.exports